import { yupResolver } from "@hookform/resolvers/yup";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import httpClient from "services/network/httpClient";
import Input from "components/Input";
import PillButton from "components/button/Pills";
import { showToast } from "components/Toaster";
import React from "react";
import { ValidationSchemas, createValidationMessage } from "utility/validationUtils";

const validationSchema = yup.object().shape({
  farmerName: ValidationSchemas.string('Farmer Name'),
  village: ValidationSchemas.string('Village'),
  houseNumber: ValidationSchemas.string('House Number'),
  pinCode: ValidationSchemas.postalCode(),
  state: ValidationSchemas.string('State'),
  district: ValidationSchemas.string('District'),
  tehsilMandal: ValidationSchemas.string('TehsiMandal'),
  // farmerContactNumber removed from schema, handled separately
});

interface UpdateProps {
  onClose: () => void;
  getData: () => void;
  data: any;
}

const UpdateFarmerDetails = ({ data, onClose, getData }: UpdateProps) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...data },
  });
  const [farmerContactNumber, setFarmerContactNumber] = React.useState(
    data.farmerContactNumber ? data.farmerContactNumber : ""
  );
  const [dialCode, setDialCode] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");

  const submit = (newData: any) => {
    if (!farmerContactNumber || farmerContactNumber.length < 6) {
      setPhoneError(createValidationMessage('Farmer Contact Number').required);
      return;
    }
    setPhoneError("");
    let nationalNumber = farmerContactNumber;
    if (nationalNumber.startsWith("+")) {
      nationalNumber = nationalNumber.slice(1);
    }
    if (dialCode && nationalNumber.startsWith(dialCode)) {
      nationalNumber = nationalNumber.slice(dialCode.length);
    }
    nationalNumber = nationalNumber.replace(/^0+/, "");
    const payload = {
      ...newData,
      farmerContactNumber: `+${dialCode}${nationalNumber}`,
      // countryCode: dialCode,
    };
    httpClient
      .put(`farmers/update`, payload)
      .then((response) => {
        console.log("Inside Update Farmers response ");
        if (response.success === true) {
          showToast("Farmer details updated successfully", "success");
        } else {
          const message =
            response?.error?.message?.toLowerCase().includes("exist")
              ? "A farmer with this contact number already exists."
              : response?.error?.message;

          showToast(message, "error");
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("something went wrong", "error");
      })
      .finally(() => {
        onClose();
        getData();
      });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(submit)} className="p-2">
        {/* Using flex-1 along with w-full to make the input flexible */}
        <div className=" md:grid md:grid-cols-3 gap-10 p-2">
          <div className="w-full md:col-span-1">
            <Input
              name={"farmerName"}
              label={"Farmer Name"}
              placeholder="Enter Farmer Name"
              required={true}
              onlyLetters
            />
          </div>

          <div className="w-full col-span-1">
            <Input
              name={"houseNumber"}
              label={"House Number"}
              placeholder="Enter Farmer House Number"
              required={true}
            />
          </div>

          <div className="w-full col-span-1 ">
            <label htmlFor="farmerContactNumber" className="mb-1 font-medium text-gray-900 dark:text-gray-200">Farmer Contact Number<span className="text-red-500">*</span></label>
            <PhoneInput
              country={"in"}
              value={farmerContactNumber}
              onChange={(value, country) => {
                setFarmerContactNumber(value);
                setDialCode((country as CountryData).dialCode ?? "");
              }}
              //phone input field background and dropdown background color
              inputClass="!w-full !bg-white !text-[#374151] dark:!bg-gray-800 dark:!text-white !border-none"
              buttonClass="!bg-white dark:!bg-gray-700"
              dropdownClass="
  !bg-white !text-[#374151] 
  dark:!bg-gray-800 dark:!text-white

  [&>.country:hover]:!bg-gray-100 
  [&>.country:hover]:!text-black
  dark:[&>.country:hover]:!bg-gray-700 
  dark:[&>.country:hover]:!text-white

  [&>.country.highlight]:!bg-gray-200 
  [&>.country.highlight]:!text-black
  dark:[&>.country.highlight]:!bg-gray-700 
  dark:[&>.country.highlight]:!text-white"//text color when cursor over the dropdown
              inputProps={{
                name: "farmerContactNumber",
                id: "farmerContactNumber",
                required: true,
                autoFocus: false,
              }}
              searchClass="!text-black dark:!text-black !bg-white dark:!bg-gray-700" //seach field text color
              enableSearch
              inputStyle={{ width: "100%" }}
              buttonStyle={{ border: "none", background: "none" }}
              containerStyle={{
                width: "100%",
                borderRadius: "0.5rem",
                border: "1px solid #d1d5db",   // <- light mode border visible
              }}
            />
            {phoneError && (
              <span className="text-red-500 text-xs mt-1">{phoneError}</span>
            )}
          </div>

          <div className="w-full col-span-1">
            <Input
              name={"village"}
              label={"Village"}
              placeholder="Enter Farmer Village"
              required={true}
              onlyLetters
            />
          </div>

          <div className="w-full col-span-1">
            <Input
              name={"district"}
              label={"District"}
              placeholder="Enter Farmer District"
              required={true}
              onlyLetters
            />
          </div>

          <div className="w-full col-span-1">
            <Input
              name={"state"}
              label={"State"}
              placeholder="Enter Farmer State"
              required={true}
              onlyLetters
            />
          </div>

          <div className="w-full col-span-1 ">
            <Input
              name={"tehsilMandal"}
              label={"Tehsil Mandal"}
              placeholder="Enter Farmer Tehsil Mandal"
              required={true}
              onlyLetters
            />
          </div>

          <div className="w-full col-span-1">
            <Input
              name={"pinCode"}
              label={"PIN Code"}
              maxLength={6}
              onlyDigits
              placeholder="Enter 6-digit PIN Code"
              required={true}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-row items-center justify-end gap-10">
          <PillButton type="submit" variant="secondary">
            {" "}
            Submit{" "}
          </PillButton>
          <PillButton type="reset" variant="primary" onClick={onClose}>
            {" "}
            Cancel{" "}
          </PillButton>
        </div>
      </form>
    </FormProvider>
  );
};
export default UpdateFarmerDetails;
